import { add, edit } from "../../../controllers/Careers/Department";
import "../index.css";
const DepartmentForm = ({ data, refresh }) => {
  const WrapperId = "DepartmentFormWrapper";
  const FormId = "DepartmentForm";
  let toggleForm = () => {
    refresh();
    document.getElementById(WrapperId).classList.toggle("hide");
    document.getElementById(FormId).reset();
  };
  let formSubmitHandle = (e) => {
    e.preventDefault();
    add(e.target.Department.value).then((res) => {
      toggleForm();
    });
  };
  let formEditHandle = (e) => {
    e.preventDefault();
    edit(data._id,e.target.Department.value).then((res) => {
      toggleForm();
    });
  };
  return (
    <>
      <div
        className="flex justify-center items-center bg-[#254fc4] text-white h-[35px] cursor-pointer hover:bg-[#8445c3]"
        onClick={() => {
          document.getElementById(WrapperId).classList.toggle("hide");
        }}
      >
        Add Department
      </div>
      <div
        id={WrapperId}
        className={"FormWrapper " + `${data ? " " : "hide"}`}
        onClick={toggleForm}
      >
        <form
          onClick={(e) => {
            e.stopPropagation();
          }}
          id={FormId}
          className="Form"
          onSubmit={(e) => {
            if (data) {
              formEditHandle(e);
            } else formSubmitHandle(e);
          }}
        >
          <div
            className="closeFormBtn"
            onClick={(e) => {
              e.stopPropagation();
              toggleForm();
            }}
          >
            <img src="/asset/close.png" width={20} alt="Close" />
          </div>
          <label>Department</label>
          <input type="text" name="Department" defaultValue={data?.type}/>
          <div className="wrap-submit">
            <input type="submit" />{" "}
          </div>
        </form>
      </div>
    </>
  );
};

export default DepartmentForm;
